export function setCompanyStyle(settings) {
    const primaryColor = settings?.primary_color || '#115571';
    const faviconUrl = settings?.favicon || require('../assets/lite/favicon.png');

    const companyStyleElement = document.getElementById('company-style');
    const companyIconElement = document.getElementById('company-icon');
    const companyShortcutIconElement = document.getElementById('company-shortcut-icon');

    if (!companyIconElement) {
        const link = document.createElement('link');
        link.id = 'company-icon';
        link.rel = 'icon';
        link.type = 'image/x-icon';
        link.href = faviconUrl;
        document.head.appendChild(link);
    } else {
        companyIconElement.href = faviconUrl;
    }

    if (!companyShortcutIconElement) {
        const link = document.createElement('link');
        link.id = 'company-shortcut-icon';
        link.rel = 'shortcut icon';
        link.type = 'image/x-icon';
        link.href = faviconUrl;
        document.head.appendChild(link);
    } else {
        companyShortcutIconElement.href = faviconUrl;
    }

    window.document.title = settings?.name || 'Draaiboek Online';

    if (companyStyleElement) {
        companyStyleElement.innerHTML = `
            .dropzone-wrapper .dropzone-loading:after {
                border-top: 3px dotted ${primaryColor}!important;
            }

            .theme-company .vdatetime-popup__header,
            .theme-company .vdatetime-calendar__month__day--selected > span > span,
            .theme-company .vdatetime-calendar__month__day--selected:hover > span > span,
            .btn-company,
            .btn-company:hover,
            .player-progress-bar .progress-bar-visual .progress-bar-handle,
            .player-progress-bar .progress-bar-visual .progress-bar-content {
                background: ${primaryColor}!important;
            }

            .theme-company .vdatetime-year-picker__item--selected,
            .theme-company .vdatetime-time-picker__item--selected,
            .theme-company .vdatetime-popup__actions__button {
                color: ${primaryColor}!important;
            }

            .block-timeline.active .block-timeline-inner {
                border-bottom-color: ${primaryColor}!important;
            }

            #settings select:focus,
            #settings input[type="text"]:focus {
                border: 1px solid ${primaryColor}!important;
            }

            #settings input[type="submit"] {
                background-color: ${primaryColor}!important;
            }

            .loginscreen {
                background-image: url('${settings?.background_image || require('../assets/lite/guest-background.jpg')}')
            }

            ${settings?.custom_css || ''}
        `;
    }
}
